// hdr-maatcode-zoeker.js - gedeelde maatcode-zoek-combobox (single source of truth).
// Gebruikt door snippets/hdr-maatcode-zoeker.liquid op: homepage-hero (Optie 2),
// /pages/maatwijzer (code-route) en categoriepagina's (maatfinder-blok).
// De native <select> blijft de bron + no-JS fallback; JS bouwt er een
// toegankelijke zoek-combobox bovenop (WAI-ARIA combobox + listbox).
// Multi-instance: elke form[data-ht-codejump] krijgt zijn eigen combobox-state.

// Fallback-submit (no-JS submit én CTA-klik): spring naar de maatcode-collectie.
window.HetDakraamCodeJump = function(form) {
  var resolved = form.__htComboResolve ? form.__htComboResolve() : null;
  if (resolved) { window.location.href = '/collections/' + resolved; return false; }
  var sel = form.querySelector('select[name="code"]');
  if (sel && sel.value) { window.location.href = '/collections/' + sel.value; }
  return false;
};

(function() {
  if (window.__htComboInit) return;
  window.__htComboInit = true;

  function norm(s) {
    return (s || '').toLowerCase().replace(/[\s×x*\/.,\-]/g, '');
  }
  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function initForm(form) {
    if (form.__htComboReady) return;
    var combo = form.querySelector('[data-ht-combo]');
    var input = form.querySelector('.hetdakraam-combo__input');
    var listbox = form.querySelector('.hetdakraam-combo__list');
    var clearBtn = form.querySelector('.hetdakraam-combo__clear');
    var fallback = form.querySelector('[data-ht-fallback]');
    var select = form.querySelector('select[name="code"]');
    var brandBtns = form.querySelectorAll('.hetdakraam-brand-btn');
    var submitBtn = form.querySelector('button[type="submit"]');
    var card = form.closest('.hetdakraam-path');
    if (!combo || !input || !listbox || !select) return;
    form.__htComboReady = true;

    // Unieke optie-id-prefix per instance (aria-activedescendant)
    var optPrefix = (listbox.id || 'ht-code-listbox') + '-opt-';


    // 1) Data-model opbouwen uit de <select>-opties (single source of truth).
    //    Groeperen op moderne code → oude codes worden zoekbare aliassen op
    //    dezelfde bestemming i.p.v. losse regels.
    var byCode = {}, order = [];
    Array.prototype.forEach.call(select.querySelectorAll('option'), function(opt) {
      var val = opt.getAttribute('value');
      if (!val) return; // placeholder overslaan
      var brand = opt.getAttribute('data-brand') || '';
      var raw = (opt.textContent || '').trim();
      var star = raw.indexOf('⭐') !== -1;
      var nonstd = raw.indexOf('niet-standaard') !== -1;
      var alias = null, rest = raw;
      var ai = raw.indexOf('→');
      if (ai !== -1) { alias = raw.slice(0, ai).trim(); rest = raw.slice(ai + 1); }
      var cm = rest.match(/^\s*([A-Za-z0-9\/]+)/);
      var code = cm ? cm[1] : rest.trim();
      var dm = rest.match(/\(([^)]+)\)/);
      var dims = dm ? dm[1].trim() : '';
      var key = code.toUpperCase();
      var e = byCode[key];
      if (!e) {
        e = { code: code, brand: brand, value: val, dims: dims, star: false, nonstandard: false, aliases: [] };
        byCode[key] = e; order.push(key);
      }
      // standaard-collectiehandle krijgt voorrang als bestemming
      if (/^(velux-[a-z]{2}\d{2}|roto-\d+-\d+)$/.test(val)) e.value = val;
      if (dims && !e.dims) e.dims = dims;
      if (star) e.star = true;
      if (nonstd) e.nonstandard = true;
      if (!e.brand) e.brand = brand;
      if (alias) { var a = alias.toUpperCase(); if (e.aliases.indexOf(a) === -1) e.aliases.push(a); }
    });
    var entries = order.map(function(k) {
      var e = byCode[k];
      e.search = norm(e.code + ' ' + e.dims + ' ' + e.aliases.join(' '));
      e.codeNorm = norm(e.code);
      e.aliasNorms = e.aliases.map(norm);
      return e;
    });
    if (entries.length === 0) return; // niets te verrijken → native select-fallback laten staan

    // Merk-state
    var activeBrand = 'velux';
    var ab = form.querySelector('.hetdakraam-brand-btn.is-active');
    if (ab && ab.dataset.brand) activeBrand = ab.dataset.brand;

    // Dynamische merk-tellingen (standaard-maten, drift-vrij) → accurate knoplabels
    var counts = {};
    entries.forEach(function(e) { if (!e.nonstandard) counts[e.brand] = (counts[e.brand] || 0) + 1; });
    Array.prototype.forEach.call(brandBtns, function(b) {
      var br = b.dataset.brand;
      // Alleen de count-span bijwerken - textContent zou het logo-img wegvagen.
      var cntEl = b.querySelector('.hetdakraam-brand-btn__count');
      if (counts[br] && cntEl) cntEl.textContent = '(' + counts[br] + ')';
    });

    var results = [], activeIndex = -1;

    function filter(q) {
      var nq = norm(q);
      // Typeplaatjes tonen vaak het modeltype vóór de maatcode ("GGL 14",
      // "GGU M06") - het modeltype zegt niets over de maat: strippen vóór match.
      var hadPrefix = /^(ggls|ggl|ggu|gpl|gpu|ghl|ghu|gfl|gzl|gxl|gdl|gil|gel|wdf)/.test(nq);
      nq = nq.replace(/^(ggls|ggl|ggu|gpl|gpu|ghl|ghu|gfl|gzl|gxl|gdl|gil|gel|wdf)/, '');
      var pool = entries.filter(function(e) { return e.brand === activeBrand; });
      if (!nq) {
        results = pool.slice().sort(function(a, b) {
          return ((b.star ? 1 : 0) - (a.star ? 1 : 0)) || a.code.localeCompare(b.code);
        });
        return;
      }
      // Complete code getypt (exacte code-/oude-code-match, mét model-voorvoegsel
      // of ≥3 tekens zoals "306"/"M06")? Dan alléén die match tonen - een lijst
      // substring-treffers eronder is dan ruis. Bij half-getypte invoer ("40…")
      // blijft de gewone substring-lijst werken.
      var exact = pool.filter(function(e) {
        return e.codeNorm === nq || e.aliasNorms.indexOf(nq) !== -1;
      });
      if (exact.length && (hadPrefix || nq.length >= 3)) {
        results = exact;
        return;
      }
      results = pool.filter(function(e) { return e.search.indexOf(nq) !== -1; })
        .sort(function(a, b) {
          // exacte code- of oude-code-match wint altijd (bijv. "4" → SK06 via GGL 4)
          var ax = (a.codeNorm === nq || a.aliasNorms.indexOf(nq) !== -1) ? 0 : 1;
          var bx = (b.codeNorm === nq || b.aliasNorms.indexOf(nq) !== -1) ? 0 : 1;
          if (ax !== bx) return ax - bx;
          var as = a.codeNorm.indexOf(nq) === 0 ? 0 : 1;
          var bs = b.codeNorm.indexOf(nq) === 0 ? 0 : 1;
          if (as !== bs) return as - bs;
          if ((b.star ? 1 : 0) !== (a.star ? 1 : 0)) return (b.star ? 1 : 0) - (a.star ? 1 : 0);
          return a.code.localeCompare(b.code);
        });
    }

    function render() {
      listbox.innerHTML = '';
      if (results.length === 0) {
        var empty = document.createElement('li');
        empty.className = 'hetdakraam-combo__empty';
        empty.setAttribute('role', 'presentation');
        empty.innerHTML = 'Geen maat gevonden. <a href="/pages/contact">Vraag ons om hulp</a>';
        listbox.appendChild(empty);
        return;
      }
      results.forEach(function(e, i) {
        var li = document.createElement('li');
        li.className = 'hetdakraam-combo__option';
        li.id = optPrefix + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        li.dataset.value = e.value;
        li.dataset.index = i;
        var badge = '';
        if (e.nonstandard) badge = '<span class="hetdakraam-combo__badge hetdakraam-combo__badge--tag">niet-standaard</span>';
        else if (e.star) badge = '<span class="hetdakraam-combo__badge hetdakraam-combo__badge--star">⭐ populairst</span>';
        var alias = e.aliases.length ? '<span class="hetdakraam-combo__alias">ook bekend als <b>' + e.aliases.map(esc).join('</b>, <b>') + '</b></span>' : '';
        li.innerHTML =
          '<span class="hetdakraam-combo__row">' +
            '<span class="hetdakraam-combo__code">' + esc(e.code) + '</span>' +
            (e.dims ? '<span class="hetdakraam-combo__dims">' + esc(e.dims) + '</span>' : '') +
            badge +
          '</span>' + alias;
        listbox.appendChild(li);
      });
    }

    function openList() {
      if (!listbox.hidden) return;
      listbox.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (card) card.classList.add('is-combo-open');
    }
    function closeList() {
      if (listbox.hidden) return;
      listbox.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      if (card) card.classList.remove('is-combo-open');
    }

    function setActive(i, doScroll) {
      var opts = listbox.querySelectorAll('.hetdakraam-combo__option');
      if (opts.length === 0) { activeIndex = -1; input.removeAttribute('aria-activedescendant'); updateCta(); return; }
      if (i < 0) i = opts.length - 1;
      if (i >= opts.length) i = 0;
      activeIndex = i;
      Array.prototype.forEach.call(opts, function(o, idx) {
        o.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      if (doScroll) opts[i].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', optPrefix + i);
      updateCta();
    }

    // Resolutie voor CTA-knop + Enter: actieve optie > exacte code/alias > enige resultaat
    form.__htComboResolve = function() {
      if (combo.hidden) return null;
      if (activeIndex >= 0 && results[activeIndex]) return results[activeIndex].value;
      var nq = norm(input.value);
      if (!nq) return null;
      for (var i = 0; i < results.length; i++) {
        if (results[i].codeNorm === nq) return results[i].value;
        for (var j = 0; j < results[i].aliases.length; j++) {
          if (norm(results[i].aliases[j]) === nq) return results[i].value;
        }
      }
      if (results.length === 1) return results[0].value;
      return null;
    };

    function updateCta() {
      if (submitBtn) submitBtn.disabled = !form.__htComboResolve();
    }

    function go(v) {
      if (!v) return;
      select.value = v;
      window.location.href = '/collections/' + v;
    }

    function refresh(autoActivate) {
      filter(input.value);
      render();
      if (autoActivate && input.value.trim() && results.length) { setActive(0, false); }
      else { activeIndex = -1; input.removeAttribute('aria-activedescendant'); updateCta(); }
    }

    // Events
    input.addEventListener('focus', function() { refresh(false); openList(); });
    input.addEventListener('input', function() {
      clearBtn.hidden = !input.value;
      refresh(true);
      openList();
    });
    input.addEventListener('keydown', function(ev) {
      switch (ev.key) {
        case 'ArrowDown':
          ev.preventDefault();
          if (listbox.hidden) { refresh(false); openList(); }
          setActive(activeIndex + 1, true);
          break;
        case 'ArrowUp':
          ev.preventDefault();
          if (listbox.hidden) { refresh(false); openList(); }
          setActive(activeIndex - 1, true);
          break;
        case 'Enter':
          ev.preventDefault();
          var v = form.__htComboResolve();
          if (v) go(v);
          break;
        case 'Escape':
          if (!listbox.hidden) { ev.preventDefault(); closeList(); }
          else if (input.value) { input.value = ''; clearBtn.hidden = true; refresh(false); }
          break;
        case 'Tab':
          closeList();
          break;
      }
    });

    // Klik op een optie → navigeren (mousedown houdt focus zodat blur niet eerst sluit)
    listbox.addEventListener('mousedown', function(ev) { ev.preventDefault(); });
    listbox.addEventListener('click', function(ev) {
      var li = ev.target.closest ? ev.target.closest('.hetdakraam-combo__option') : null;
      if (li && li.dataset.value) go(li.dataset.value);
    });
    listbox.addEventListener('mousemove', function(ev) {
      var li = ev.target.closest ? ev.target.closest('.hetdakraam-combo__option') : null;
      if (li && li.dataset.index != null && li.dataset.index !== '') setActive(parseInt(li.dataset.index, 10), false);
    });

    clearBtn.addEventListener('click', function() {
      input.value = '';
      clearBtn.hidden = true;
      refresh(false);
      openList();
      input.focus();
    });

    // Merk-filter: scope de combobox + reset de zoekterm
    Array.prototype.forEach.call(brandBtns, function(btn) {
      btn.addEventListener('click', function() {
        activeBrand = btn.dataset.brand;
        Array.prototype.forEach.call(brandBtns, function(b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        input.value = '';
        clearBtn.hidden = true;
        refresh(false);
        openList();
        input.focus();
      });
    });

    // Buiten de combobox klikken/tabben → sluiten
    combo.addEventListener('focusout', function(ev) {
      if (!combo.contains(ev.relatedTarget)) closeList();
    });
    document.addEventListener('mousedown', function(ev) {
      if (!combo.contains(ev.target)) closeList();
    });

    // 2) JS aanwezig → combobox tonen, native select verbergen (+ required eraf
    //    zodat een verborgen verplicht veld de form-submit niet blokkeert).
    combo.hidden = false;
    if (fallback) fallback.hidden = true;
    select.removeAttribute('required');
    updateCta();
  }

  function init() {
    var forms = document.querySelectorAll('form[data-ht-codejump]');
    Array.prototype.forEach.call(forms, initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
